import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  BrowserRouter, Route, Switch, Redirect
} from 'react-router-dom';

import routes from './base';
import { PrivateRouter } from '../components';
import * as Helpers from '../helpers';
import * as Actions from '../store/actions';

const token = Helpers.token.get();
export default connect(
  null,
  Actions
)(
  class Routes extends Component {
    async componentDidMount() {
      const { load } = this.props;
      // eslint-disable-next-line no-console
      console.log('Token: ', token);
      if (token) {
        load();
      }
    }

    component = route => connect(
      state => state,
      Actions
    )(props => <route.component {...props} {...this.props} />);

    render() {
      return (
        <BrowserRouter>
          <Switch>
            {routes.public.map(route => (
              <Route
                key={route.path}
                path={route.path}
                exact={route.exact}
                component={this.component(route)}
              />
            ))}
            {routes.private.map(route => (
              <PrivateRouter
                key={route.path}
                path={route.path}
                exact={route.exact}
                component={this.component(route)}
              />
            ))}
            <Route
              path="/404"
              component={() => (
                <div
                  id="not-found"
                >
                  404
                </div>
              )}
            />
            <Route exact path="/">
              <Redirect to={token ? '/dashboard' : '/home'} />
            </Route>
            <Route exact={false} path="*">
              <Redirect to="/404" />
            </Route>
          </Switch>
        </BrowserRouter>
      );
    }
  }
);
